// extracted by mini-css-extract-plugin
export default {"loginTitle":"LoginHeaderText_loginTitle__4x22u","loginParagraph":"LoginHeaderText_loginParagraph__5RgA+"};